import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ─── Shot Breakdown Import ───────────────────────────────────
// Cloud-mode feature: the document is parsed + LLM-extracted server-side.

/** Upload a shot-breakdown document and get a parsed preview (NOT persisted). */
export async function previewBreakdown(file, projectId) {
  const form = new FormData();
  form.append('file', file);
  form.append('project_id', projectId);
  const { data } = await axios.post(`${API}/shot-import/preview`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

/** Commit a (possibly user-edited) preview payload — persists pending shots. */
export async function commitBreakdown(payload) {
  const { data } = await axios.post(`${API}/shot-import/commit`, payload);
  return data;
}

/** List shot-breakdown imports for a project. */
export async function listBreakdownImports(projectId) {
  const { data } = await axios.get(`${API}/shot-import/${projectId}`);
  return data;
}

/** List imported + expansion anchors (image data stripped). */
export async function getImportedShots(projectId) {
  const { data } = await axios.get(`${API}/shot-import/${projectId}/anchors`);
  return data;
}

// ─── Visualize (Phase 2) ─────────────────────────────────────

/** Kick off Stage 2/3 rendering over pending imported anchors. */
export async function visualizeImport(payload) {
  const { data } = await axios.post(`${API}/shot-import/visualize`, payload);
  return data;
}

// ─── Expand Beyond (Phase 3) ─────────────────────────────────

/** Propose N micro-inserts for a beat or beat-group (NOT persisted). */
export async function proposeExpansion(payload) {
  const { data } = await axios.post(`${API}/shot-import/expand`, payload);
  return data;
}

/** Persist accepted micro-inserts as child anchors. */
export async function commitExpansion(payload) {
  const { data } = await axios.post(`${API}/shot-import/expand/commit`, payload);
  return data;
}
